import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "employers" }

import { ref, computed, onMounted, watch } from "vue";
import { Applicant, SurveyResponse } from "@/models/application";
import { SurveyQuestionTypeIds } from "@/config/constants";
import useHtmlUtilities from "@/use/htmlUtilities";
import { Form } from "vee-validate";
import { EmployerTypeIds, EmployerRecord } from "@/models/employer";
import AddEmployerForm from "@/components/checklist/income-verification/AddEmployerForm.vue";
import { validateStringInput } from "@/use/validation";


export default /*@__PURE__*/_defineComponent({
  __name: 'Employers',
  props: {
    applicant: {}
  },
  setup(__props: any, { expose: __expose }) {

const { decodeHTMLEncodedStr } = useHtmlUtilities();

const props = __props;

const formRef = ref<InstanceType<typeof Form>>();
const employerInput = ref<Array<InstanceType<typeof AddEmployerForm>>>(); // This will become an array of DOM elements

const employers = ref<EmployerRecord[]>([]);
const employerRecordsCount = ref<number>(1);

const employments = computed<Array<string>>(() => getInputs());

const isValid = computed<boolean>(() =>
  formRef.value && formRef.value.errors ? Object.keys(formRef.value?.errors)?.length <= 0 : false,
);

function addItemToList() {
  employerRecordsCount.value++;

  const employer = new EmployerRecord({
    id: employerRecordsCount.value,
    employerName: undefined,
    employerTypeId: EmployerTypeIds.Additional,
  });

  employers.value.push(employer);
}

function removeItemFromList(id: number) {
  const index = employers.value.findIndex((e: EmployerRecord) => e.id === id);
  if (index !== -1) {
    employers.value.splice(index, 1);
  }
}

const employerNameSurveyResponse = computed<SurveyResponse | undefined>(() =>
  props.applicant?.surveyResponses?.find(
    (s: SurveyResponse) => s.questionId === SurveyQuestionTypeIds.EmployerName,
  ),
);

function getCurrentEmployer() {
  if (employerNameSurveyResponse.value) {
    const employer = new EmployerRecord({
      id: employerRecordsCount.value,
      employerName: employerNameSurveyResponse.value?.response,
      employerTypeId: EmployerTypeIds.Current,
    });

    if (employers.value.length === 0) {
      employers.value.push(employer);
    } else {
      employers.value.splice(0, 1, employer);
      if (employerInput.value) {
        employerInput.value[0]?.setValue(employer.employerName);
      }
    }
  }
}

function getInputs() {
  return employers.value
    .filter((e: EmployerRecord) => validateStringInput(e.employerName))
    .map((e: EmployerRecord) => e.employerName as string);
}

onMounted(() => {
  getCurrentEmployer();
});

//add watch for the current employer name external change via income verification checkbox area
watch(employerNameSurveyResponse, (newVal, oldVal) => {
  if (newVal === oldVal) {
    return;
  }

  getCurrentEmployer();
});

__expose({
  employers,
  formRef,
  isValid,
  getInputs,
  employments,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Form), {
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employers.value, (employer) => {
            return (_openBlock(), _createBlock(AddEmployerForm, {
              ref_for: true,
              ref_key: "employerInput",
              ref: employerInput,
              key: employer.id,
              employer: employer,
              initialValue: employer.employerName,
              name: `employer_${employer.id}`,
              onDeleteEmployer: removeItemFromList,
              onUpdateModelValue: ($event: any) => (employer.employerName = $event)
            }, null, 8, ["employer", "initialValue", "name", "onUpdateModelValue"]))
          }), 128))
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("div", { class: "sc-forms-link" }, [
      _createElementVNode("a", {
        class: "text-decoration-underline",
        onClick: addItemToList
      }, "+Add an additional employer")
    ])
  ], 64))
}
}

})